module.exports = __webpack_public_path__ + "static/the-gulag-archipelago-53e19511393aebf20982ffec27b32fa4.jpg";